module.exports = __webpack_public_path__ + "static/vita-jones-0e7187ec84a3e3c856eb2c4e85c278ca.jpg";